module.exports = __webpack_public_path__ + "static/18-0b4261da8fa870e588e5d50218e54b86.jpg";